import React from "react";
import WorkspaceInternalControls from "../../libraries/WorkspaceInternalControls";

interface RightOfUseAssetsInternalControlsProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
  controlsListSection?: string;
}

export default function RightOfUseAssetsInternalControls({ onBack, setActiveSection, controlsListSection }: RightOfUseAssetsInternalControlsProps) {
  return (
    <WorkspaceInternalControls
      workspaceName="Right-of-Use Assets"
      onBack={onBack}
      setActiveSection={setActiveSection}
      controlsListSection={controlsListSection}
    />
  );
}
